import React from "react";
import { Input, Box } from "@chakra-ui/react/dist/chakra-ui-react.cjs";
import ReactDatePicker, { registerLocale } from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import ja from "date-fns/locale/ja";

registerLocale("ja", ja);

const EDatePickerInput = React.forwardRef(({ value, onClick, onChange, placeholder, width, fontSize, maxLength, onKeyDown, onInput }, ref) => (
  <Input
    ref={ref}
    value={value || ""}
    onClick={onClick}
    onChange={onChange}
    onKeyDown={onKeyDown}
    onInput={onInput}
    placeholder={placeholder || "YYYY"}
    fontSize={fontSize || "14px"}
    w={width}
    maxLength={maxLength}
    _focus={{ boxShadow: "none", outline: "none", borderColor: "#e2e8f0" }}
    style={{ outline: "none" }}
  />
));

const EDatePicker = ({
  selected,
  onChange,
  placeholder = "YYYY",
  width = "180px",
  fontSize = "14px",
  showYearPicker = false,
  showMonthYearPicker = false,
  dateFormat = "yyyy",
  maxLength,
  onKeyDown,
  onInput,
}) => {
  return (
    <Box>
      <ReactDatePicker
        selected={selected}
        onChange={onChange}
        showYearPicker={showYearPicker}
        showMonthYearPicker={showMonthYearPicker}
        dateFormat={dateFormat}
        placeholderText={placeholder}
        locale="ja"
        customInput={<EDatePickerInput width={width} fontSize={fontSize} maxLength={maxLength} onKeyDown={onKeyDown} onInput={onInput} />}
      />
    </Box>
  );
};

export default EDatePicker;


